// IE 2026 09 21 / ODOO-5800 (Igor 21.09, скрин Purchase Balance под чипсом поиска «Беларусь»: «При чипсе-фильтре строк без флага "Show rows without matches" нужно пересчитывать
// итоги. Давай сделаем это как опция, пока в коде, по умолчанию вкл»): ИТОГИ СТРОК-ГРУПП ПО ОТБОРУ — чистая логика, без Vue и DOM.
// Итог строки-группы отчёта считает бэк (data_layout2.get_data_value) по ВСЕМ строкам данных группы; чипс таблицы прячет подчинённые строки на фронте, и итог расходится с тем,
// что видно. Здесь итог пересчитывается по видимым после отбора подчинённым строкам — ТОЛЬКО ДЛЯ ПОКАЗА: значения строк данных не меняются, результат — побочная карта
// «строка → {колонка: значение}», грид подставляет её при отрисовке (AttrGrid.foldAgg_value) и снимает вместе с отбором — итоги бэка возвращаются байт в байт.
// Пересчитывается только то, что фронт ДОСТОВЕРНО воспроизводит: правило агрегата ячейки известно и формула по значениям ВСЕХ прямых подчинённых даёт итог бэка (самопроверка на
// каждой группе и колонке); иначе остаётся значение бэка:
//   Sum / None / opening_balance / closing_balance / Cnt — сумма (у остатков итог по узлам на дату — сумма; по времени у ячейки одна дата);
//   Max / Min — максимум / минимум; WAvg — средневзвешенное по весам соседней колонки <binding>_w (весов нет — не пересчитывается);
//   Avg, CntDst, First, Last, accuracy_pct, статусы, наборы id и прочее — не пересчитываются (по значениям подчинённых строк не восстановить).
// Группа, у которой колонка не воспроизвелась, «портит» эту колонку у предков: смешивать итог по отбору с итогом по всем строкам нельзя — предки тоже остаются со значением бэка.
// IE 2026 09 24 / ODOO-5800: строки вне итога родителя (бэк _DLRow.total_excluded: memo «· of which …» и др.) слагаемыми родителя не считаются — как на бэке (detached, см. ниже).
import { t } from '@/i18n'   // IE 2026 09 23 / ODOO-341407: i18n — подсказки ленивые: модуль грузится до словаря, поэтому FT_HINT() / FT_STALE_HINT()
export const FT_HINT = () => t('Total of the rows that match the filter')   // IE 2026 09 23 / ODOO-341407: i18n
export const FT_STALE_HINT = () => t('Total of all rows - it is not recalculated by the row filter')   // IE 2026 09 23 / ODOO-341407: i18n
const SUM_RULES = new Set(['Sum', 'None', 'opening_balance', 'closing_balance', 'Cnt'])
const EPS = 1e-6

function numOf(v) {
    if (typeof v === 'number') return Number.isNaN(v) ? null : v
    if (typeof v === 'string' && v.trim() !== '') { const n = Number(v); return Number.isNaN(n) ? null : n }
    return null
}
const same = (a, b) => Math.abs(a - b) <= EPS * Math.max(1, Math.abs(a), Math.abs(b))

// колонка для расчёта: { binding, path } — путь разбирается один раз (значение ячейки — flat-ключ либо путь через точку, как store.get_value)
export function ft_col(binding, ruleOf, weightBinding = '') {
    const b = String(binding || '')
    return { binding: b, path: b.split('.'), ruleOf, wBinding: weightBinding, wPath: weightBinding ? String(weightBinding).split('.') : null }
}
export function ft_read(item, binding, path) {
    if (!item || typeof item !== 'object') return undefined
    if (binding in item) return item[binding]
    let v = item
    for (let i = 0; i < path.length; i++) {
        if (v === null || typeof v !== 'object' || !(path[i] in v)) return undefined
        v = v[path[i]]
    }
    return v
}
export function ftRule_kind(rule) {
    if (SUM_RULES.has(rule)) return 'sum'
    if (rule === 'Max') return 'max'
    if (rule === 'Min') return 'min'
    if (rule === 'WAvg') return 'wavg'
    return ''
}

/**
 * rows — строки грида в порядке показа: { level, visible, item, skip, detached }; item — СЫРОЙ объект строки данных (ключ карты), skip — строка вне арифметики дерева (строка сравнения);
 * detached — строка ВНЕ итога родителя (бэк: _DLRow.total_excluded — memo «· of which …» и строки, не прошедшие отбор строки-зонта): в подчинённые родителя не входит
 * (ни в самопроверку, ни в сумму, её спрятанность не «пачкает» родителя), а своё поддерево считает как обычная группа.
 * cols — колонки ft_col(...). Возвращает { map: Map(item → {binding: число | null}), stale: Map(item → Set(binding)), stats }; null в карте — «ячейка пуста» (бэк нулевые
 * итоги не пишет); stale — ячейки затронутых отбором групп, оставшиеся с итогом бэка ПО ВСЕМ строкам (правило не воспроизводится) — грид их приглушает.
 */
export function filterTotals_compute(rows, cols) {
    const n = rows.length
    const kids = new Array(n)
    const stack = []
    let detached = 0
    for (let i = 0; i < n; i++) {
        const r = rows[i]
        if (!r || r.skip) continue
        while (stack.length && rows[stack[stack.length - 1]].level >= r.level) stack.pop()
        // IE 2026 09 24 / ODOO-5800 (Igor, скрин 1fxa_001 под поиском «PSP Pharma Ltd»: в 58:27 — 31 633, итог по ВСЕМ строкам): memo-строка «· of which expired» (161 за 2026-09)
        // стояла среди подчинённых «Грузии» слагаемым — самопроверка 2 808 ≠ 2 969 проваливалась, ячейка оставалась с итогом бэка (ft-stale), а «Ex-Delta» — «испорченной» колонкой.
        // Строка вне итога родителя в подчинённые не записывается, но в стек идёт — её собственные подчинённые считаются под ней
        if (stack.length && !r.detached) { const p = stack[stack.length - 1]; (kids[p] || (kids[p] = [])).push(i) }
        else if (stack.length) detached++
        stack.push(i)
    }
    // группа затронута отбором: у неё есть спрятанная подчинённая строка (на любом уровне ниже)
    const dirty = new Uint8Array(n)
    for (let i = n - 1; i >= 0; i--) {
        const k = kids[i]
        if (!k) continue
        for (let j = 0; j < k.length; j++) if (!rows[k[j]].visible || dirty[k[j]]) { dirty[i] = 1; break }
    }
    const map = new Map()
    const taint = new Map()   // индекс строки → Set(binding): колонка группы осталась со значением бэка при спрятанных подчинённых
    const stats = { groups: 0, cells: 0, emptied: 0, unchanged: 0, notReproduced: 0, tainted: 0, skippedByRule: {}, samples: [], detached }   // IE 2026 09 24 / ODOO-5800: detached — строк вне итога родителя
    const note = (i, b, rule, pv, all) => { if (stats.samples.length < 12) stats.samples.push({ row: i, binding: b, rule, backend: pv, children: all }) }   // образцы невоспроизведённого — для разбора
    const ovr = (i, b) => { const o = map.get(rows[i].item); return o && b in o ? o[b] : undefined }
    const put = (i, b, v) => { let o = map.get(rows[i].item); if (!o) { o = {}; map.set(rows[i].item, o) } o[b] = v }
    const stale = new Map()
    const mark = (i, b) => { let s = taint.get(i); if (!s) { s = new Set(); taint.set(i, s) } s.add(b)
        let t = stale.get(rows[i].item); if (!t) { t = new Set(); stale.set(rows[i].item, t) } t.add(b) }
    for (let i = n - 1; i >= 0; i--) {
        const k = kids[i]
        if (!k || !dirty[i] || !rows[i].visible) continue
        stats.groups++
        const item = rows[i].item
        for (let c = 0; c < cols.length; c++) {
            const col = cols[c], b = col.binding
            const pv = numOf(ft_read(item, b, col.path))
            // подчинённая группа с «испорченной» колонкой — итог выше тоже не трогаем
            let bad = false
            for (let j = 0; j < k.length && !bad; j++) if (rows[k[j]].visible && taint.get(k[j])?.has(b)) bad = true
            if (bad) { if (pv !== null) { mark(i, b); stats.tainted++ } continue }
            const kind = ftRule_kind(col.ruleOf(item))
            if (!kind) {
                if (pv !== null) { mark(i, b); const r = String(col.ruleOf(item)); stats.skippedByRule[r] = (stats.skippedByRule[r] || 0) + 1 }
                continue
            }
            let all = null, vis = null, any = false
            if (kind === 'wavg') {
                if (!col.wPath) { if (pv !== null) { mark(i, b); stats.skippedByRule['WAvg (no weights)'] = (stats.skippedByRule['WAvg (no weights)'] || 0) + 1 } continue }
                let aw = 0, av = 0, vw = 0, vv = 0
                for (let j = 0; j < k.length; j++) {
                    const ci = k[j], it = rows[ci].item
                    const v0 = numOf(ft_read(it, b, col.path)), w0 = numOf(ft_read(it, col.wBinding, col.wPath))
                    if (v0 !== null && w0 !== null && w0 > 0) { aw += w0; av += v0 * w0; any = true }
                    if (!rows[ci].visible) continue
                    const v1o = ovr(ci, b), w1o = ovr(ci, col.wBinding)
                    const v1 = v1o === undefined ? v0 : v1o, w1 = w1o === undefined ? w0 : w1o
                    if (v1 !== null && w1 !== null && w1 > 0) { vw += w1; vv += v1 * w1 }
                }
                if (!any) { if (pv !== null) { mark(i, b); stats.notReproduced++; note(i, b, 'WAvg (children without weights)', pv, null) } continue }
                all = aw > 0 ? av / aw : null
                if (pv === null || all === null || !same(pv, all)) { if (pv !== null) mark(i, b); stats.notReproduced++; note(i, b, 'WAvg', pv, all); continue }
                vis = vw > 0 ? vv / vw : null
                put(i, col.wBinding, vw > 0 ? vw : null)   // вес группы по отбору — предкам и свёрнутым периодам
            } else {
                let a = 0, s = 0, anyVis = false
                for (let j = 0; j < k.length; j++) {
                    const ci = k[j], v0 = numOf(ft_read(rows[ci].item, b, col.path))
                    if (v0 !== null) {
                        if (!any) { a = v0; any = true }
                        else a = kind === 'sum' ? a + v0 : (kind === 'max' ? Math.max(a, v0) : Math.min(a, v0))
                    }
                    if (!rows[ci].visible) continue
                    const v1o = ovr(ci, b), v1 = v1o === undefined ? v0 : v1o
                    if (v1 !== null) {
                        if (!anyVis) { s = v1; anyVis = true }
                        else s = kind === 'sum' ? s + v1 : (kind === 'max' ? Math.max(s, v1) : Math.min(s, v1))
                    }
                }
                if (pv === null) {   // у группы значения нет: подчинённые пусты (или в сумме ноль — бэк ноль не пишет) — пересчитывать нечего; иначе итог бэка устроен иначе
                    if (any && !(kind === 'sum' && Math.abs(a) < EPS)) { stats.notReproduced++; note(i, b, kind + ' (group is empty)', pv, a) }
                    continue
                }
                if (!any || !same(pv, a)) { mark(i, b); stats.notReproduced++; note(i, b, kind, pv, any ? a : null); continue }
                all = a
                vis = anyVis ? s : null
            }
            if (vis !== null && kind !== 'max' && kind !== 'min' && Math.abs(vis) < EPS) vis = null   // нулевой итог бэк не пишет — ячейка пуста
            if (vis !== null && same(vis, pv)) { stats.unchanged++; continue }
            put(i, b, vis)
            stats.cells++
            if (vis === null) stats.emptied++
        }
    }
    stats.stale = 0; for (const t of stale.values()) stats.stale += t.size
    return { map, stale, stats }
}
